var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "input-base",
    {
      attrs: {
        overlap: _vm.overlap,
        small: _vm.small,
        transparent: _vm.transparent,
        stretched: _vm.stretched,
        slimmer: _vm.slimmer,
        squished: _vm.squished
      }
    },
    [
      !!_vm.inputLabel
        ? _c(
            "label",
            { attrs: { slot: "label", for: _vm.inputName }, slot: "label" },
            [_vm._v("\n\n    " + _vm._s(_vm.inputLabel) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "rt-options-container",
          attrs: { slot: "input" },
          slot: "input"
        },
        [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.value,
                expression: "value"
              }
            ],
            ref: _vm.taRef,
            class: _vm.getInnerStyle + " " + _vm.className,
            attrs: {
              form: _vm.parentForm,
              id: _vm.identification,
              name: _vm.inputName,
              placeholder: _vm.getPlaceholderLabel
            },
            domProps: { value: _vm.value },
            on: {
              focus: _vm.setCursorLoc,
              keypress: function($event) {
                return _vm.textAreaAdjust(_vm.taRef)
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.value = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _vm.rich
            ? _c("rt-options", {
                staticClass: "rt-options",
                on: { insertEmoji: _vm.insertEmoji }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c10e6bd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c10e6bd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/input/InputTextarea.vue
// module id = null
// module chunks = 